module.exports = __webpack_public_path__ + "img/nx_v1_2.59e14589.png";